import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {},
  tabPanel: {
    paddingRight: 72,
    paddingLeft: 72,
    paddingTop: 24,
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
      paddingLeft: 0
    }
  },
  tab: {
    fontSize: 14,
    '&.Mui-selected': {
      border: `3px solid ${theme.palette.primary.main}`,
      borderTop: 'none'
    }
  },
  btnContainer: { display: 'flex', justifyContent: 'flex-end', marginTop: 24 },
  btnText: { fontWeight: 500 },
  saveButton: { marginLeft: 8 },
  whiteText: { color: theme.palette.background.default, fontWeight: 500 },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.background.default
  }
}))

export default useStyles
